import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"how_to_use_it_title"} defaultMessage={"Como usá-la?"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ul>
                    <li>• <FormattedMessage id={"how_to_use_it_text_1"} defaultMessage={"Coloque a máscara com cuidado, certificando-se de que ela cubra a boca e o nariz e amarre-a firmemente para minimizar qualquer espaço entre o rosto e a máscara."}/></li>
                    <li>• <FormattedMessage id={"how_to_use_it_text_2"} defaultMessage={"Evite tocá-lo ao usar."}/></li>
                    <li>• <FormattedMessage id={"how_to_use_it_text_3"} defaultMessage={"Troque a máscara assim que ela fique molhada por uma máscara limpa e seca."}/></li>
                    <li>• <FormattedMessage id={"how_to_use_it_text_4"} defaultMessage={"Não reutilize máscaras de uso único."}/></li>
                </ul>
            </div>
            <div align="center">
                <a href={"/masks"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;